import React, { useMemo, useState } from 'react'

import { ALERT_TYPE, OPERATION_MODE, ShowToastMessage } from '@laramie/ui';
import { buildCellAVMR } from "../../../utils"
import {TIPS} from "../../../../../consts/tips";

import { FormError, InputNumber, InputPercent, TableCustom, FormLabel, Modal } from "../../../../../components/common"
import { useFormErrors } from '../../../../../components/hooks';

const DefinicionQuita = ({ data, setData, params, setPendingChange }) => {
    const [edittingQuita, setEdittingQuita] = useState()
    const [mode, setMode] = useState()

    const filteredData = useMemo(() => !data ? [] : data.filter(x => x.state !== 'r'), [data])

    const onAdd = (quita) => {
        setEdittingQuita({
            id: -Date.now(),
            idPlanPagoDefinicion: parseInt(params.id),
            cuotaDesde: 0,
            cuotaHasta: 0,
            porcentajeQuitaAportes: 0,
            porcentajeQuitaHonorarios: 0,
            porcentajeQuitaMultaInfracciones: 0,
            porcentajeQuitaRecargos: 0,
            state: 'a',
        })
        setMode('add')
    }

    const onView = (quita) => {
        setEdittingQuita(quita)
        setMode('view')
    }

    const onModify = (quita) => {
        setEdittingQuita(quita)
        setMode('modify')
    }

    const onRemove = (quita) => {
        setData(data.map(x => x.id === quita.id ? {...x, state: 'r'} : x))
        setPendingChange(true)
    }

    const { errorOf, validate, reset } = useFormErrors(getErrors)

    function getErrors() {
        const errors = {}
        if (!edittingQuita) return errors

        if (edittingQuita.cuotaDesde <= 0) errors.cuotaDesde = 'Ingresá un número mayor a cero'
        if (edittingQuita.cuotaHasta <= 0) errors.cuotaHasta = 'Ingresá un número mayor a cero'

        return errors
    }

    const onClickModalAccept = () => {
        if (!validate()) return

        if (edittingQuita.porcentajeQuitaRecargos <= 0 &&
            edittingQuita.porcentajeQuitaMultaInfracciones <= 0 &&
            edittingQuita.porcentajeQuitaHonorarios <= 0 &&
            edittingQuita.porcentajeQuitaAportes <= 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe cargar al menos una quita')
            return
        }

        if (mode === 'add') {
            setData([...data, edittingQuita])
        }

        else if (mode === 'modify') {
            setData(data.map(x => x.id === edittingQuita.id ? {...edittingQuita, state: edittingQuita.state === 'a' ? 'a' : 'm',} : x))
        }

        setMode(null)
        reset()

        setPendingChange(true)
    }

    const onClickModalCancel = () => {
        setEdittingQuita(null)
        setMode(null)
        reset()
    }
    
    return (
        <div className="col-12 col-md-6">

            <div className="col-12 p-top-15">
                <label className="form-label">Quita</label>
                <TableCustom
                    showFilterGlobal={false}
                    floatingDownloadCSVButton={true}
                    className='TableCustomBase'
                columns={[
                    { Header: 'Cuota desde', accessor: 'cuotaDesde', width: '30%' },
                    { Header: 'Cuota hasta', accessor: 'cuotaHasta', width: '30%' },
                    { Header: 'Porcentaje', accessor: 'porcentajeQuitaRecargos', width: '30%' },
                    buildCellAVMR({ onAdd, onView, onModify, onRemove, readOnly: params.mode === OPERATION_MODE.VIEW }),
                ]}
                data={filteredData}
                />
            </div>
    
            {!!mode && (
                <Modal
                    size="lg"
                    title="Quita"
                    tipName={TIPS.NAME.MODALS.QUITA_DEFINICION_MODAL}
                    onEscape={onClickModalCancel}
                    body={(
                                <div className="row">
                                    <div className="col-12 col-md-4">
                                        <FormLabel htmlFor="cuotaDesde" required>Cuota desde</FormLabel>
                                        <InputNumber
                                            name="cuotaDesde"
                                            placeholder=""
                                            className={`form-control ${errorOf('cuotaDesde') ? 'is-invalid' : ''}`}
                                            value={edittingQuita.cuotaDesde}
                                            onChange={({ target }) => setEdittingQuita(prev => ({...prev, cuotaDesde: target.value}))}
                                            precision={0}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError message={errorOf('cuotaDesde')} />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <FormLabel htmlFor="cuotaHasta" required>Cuota hasta</FormLabel>
                                        <InputNumber
                                            name="cuotaHasta"
                                            placeholder=""
                                            className={`form-control ${errorOf('cuotaHasta') ? 'is-invalid' : ''}`}
                                            value={edittingQuita.cuotaHasta}
                                            onChange={({ target }) => setEdittingQuita(prev => ({...prev, cuotaHasta: target.value}))}
                                            precision={0}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError message={errorOf('cuotaHasta')} />
                                    </div>

                                    <div className="col-12 col-md-4">
                                        <label htmlFor="porcentajeQuitaRecargos" className="form-label">Quita de recargos</label>
                                        <InputPercent
                                            name="porcentajeQuitaRecargos"
                                            placeholder=""
                                            className="form-control"
                                            value={edittingQuita.porcentajeQuitaRecargos}
                                            onChange={({ target }) => setEdittingQuita(prev => ({...prev, porcentajeQuitaRecargos: target.value}))}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError />
                                    </div>
                                    <div className="col-12 col-md-4 m-top-10">
                                        <label htmlFor="porcentajeQuitaMultaInfracciones" className="form-label">Quita de multas e infracciones</label>
                                        <InputPercent
                                            name="porcentajeQuitaMultaInfracciones"
                                            placeholder=""
                                            className="form-control"
                                            value={edittingQuita.porcentajeQuitaMultaInfracciones}
                                            onChange={({ target }) => setEdittingQuita(prev => ({...prev, porcentajeQuitaMultaInfracciones: target.value}))}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError />
                                    </div>

                                    <div className="col-12 col-md-4 m-top-10">
                                        <label htmlFor="porcentajeQuitaHonorarios" className="form-label">Quita de causídicos y honorarios</label>
                                        <InputPercent
                                            name="porcentajeQuitaHonorarios"
                                            placeholder=""
                                            className="form-control"
                                            value={edittingQuita.porcentajeQuitaHonorarios}
                                            onChange={({ target }) => setEdittingQuita(prev => ({...prev, porcentajeQuitaHonorarios: target.value}))}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError />
                                    </div>
                                    <div className="col-12 col-md-4 m-top-10">
                                        <label htmlFor="porcentajeQuitaAportes" className="form-label">Quita de aportes</label>
                                        <InputPercent
                                            name="porcentajeQuitaAportes"
                                            placeholder=""
                                            className="form-control"
                                            value={edittingQuita.porcentajeQuitaAportes}
                                            onChange={({ target }) => setEdittingQuita(prev => ({...prev, porcentajeQuitaAportes: target.value}))}
                                            disabled={mode === 'view'}
                                        />
                                        <FormError />
                                    </div>
                                </div>
                    )}
                    footer={(<>
                                {mode !== 'view' && (
                                <>
                                    <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onClickModalCancel}>Cancelar</button>
                                    <button className="btn btn-primary" data-dismiss="modal" onClick={onClickModalAccept}>Aceptar</button>
                                </>
                                )}
                                {mode == 'view' && (
                                    <div className="width-100p f-align">
                                        <button className="btn back-button" data-dismiss="modal" onClick={onClickModalCancel}>Volver</button>
                                    </div>
                                )}
                    </>)}
                />
            )}
        </div>
    )
}

export default DefinicionQuita